/* eslint-disable no-nested-ternary */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-undef */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Archive, XCircle } from 'react-feather';
import { useRouter } from 'next/router';
import { PuffLoader } from 'react-spinners';
import HeadMeta from '@/components/common/HeadMeta';
import { fetchAllPosts, fetchCategories } from '@/lib/apiCalls';
import Pagination from '@/components/common/Pagination';
import BlogCard from '@/components/common/BlogCard';

export default function Blog({ blogData, categories }) {
  const metaProps = {
    title: 'Blog de Entre Coach - Insights y Estrategias por Julie Ann De Armas',
    keywords:
      'Blog Entre Coach, Julie Ann De Armas, Consejos de Psicología, Técnicas de Coaching, Mejora Personal',
    description:
      'Lee el blog de Entre Coach para obtener insights y estrategias en psicología y coaching proporcionados por Julie Ann De Armas. Encuentra consejos que impulsarán tu desarrollo personal y profesional',
  };

  const router = useRouter();
  const [posts, setPosts] = useState(blogData);
  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState(router.query.category || '');
  const [page, setPage] = useState(router.query.page || '1');
  const [query, setQuery] = useState(router.query.q || '');
  const [inputValue, setInputValue] = useState(router.query.q || '');
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    const queryParams = {};
    if (category) queryParams.category = category;
    if (page) queryParams.page = page;
    if (query) queryParams.q = query;
    if (!isInitialLoad || category !== '' || page !== '1' || query !== '') {
      setPosts([]);
    }
    setLoading(true);
    axios
      .get(`${process.env.NEXT_PUBLIC_API}/posts?category=${category}&page=${page}&q=${query}`)
      .then((response) => {
        setPosts(response.data);
        if (!isInitialLoad) {
          router.push({
            pathname: '/blog',
            query: queryParams,
          });
        }
        setLoading(false);
      })
      .catch(() => {
        setPosts([]);
        setLoading(false);
      });

    setIsInitialLoad(false);
  }, [category, page, query]);

  const resetUrl = () => {
    window.location.href = '/blog';
  };
  return (
    <>
      <HeadMeta {...metaProps} />
      <section className="relative z-10 px-5 py-10 overflow-hidden md:py-20 ">
        <h1 className="hidden">Blog</h1>
        <div className="w-full max-w-xl mx-auto md:max-w-5xl 2xl:max-w-7xl text-brand-main pt-[90px]">
          <div className="w-fit !mr-auto block md:hidden">
            <h2
              className="mb-4 text-2xl md:mb-8 md:text-4xl payfair "
              data-aos="fade-up"
              data-aos-delay="200"
            >
              Recursos
            </h2>
          </div>
          <div className="flex flex-col    justify-center items-center !w-full  mx-auto md:!ml-auto md:mr-0 md:max-w-none md:w-fit md:flex-row gap-x-5">
            <div className="w-fit hidden md:block !mr-auto">
              <h2
                className="text-2xl md:text-4xl payfair"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                Recursos
              </h2>
            </div>
            {category !== '' || query !== '' ? (
              <button
                onClick={() => resetUrl()}
                type="button"
                className="flex items-center justify-center order-last p-2 mb-8 rounded-full cursor-pointer md:order-none bg-brand-main hover:bg-brand-dark"
              >
                <XCircle className="w-5 h-5 text-white" />
              </button>
            ) : null}
            {categories?.length >= 1 && (
              <div className="w-full md:w-[300px]">
                <label
                  htmlFor="location"
                  className="max-w-2xl mt-0 mb-8 text-sm font-semibold leading-6 text-neutral-800/90"
                >
                  Categoría
                </label>
                <select
                  onChange={(e) => {
                    setPage('1');
                    setCategory(e.target.value);
                  }}
                  id="location"
                  name="location"
                  className="mt-1 block  w-full !rounded-md border-0 py-3 md:py-3 pl-3 pr-10 text-gray-900 ring-1 ring-brand-main ring-inset mb-2 md:mb-8  text-base leading-6 text-neutral-800/90"
                  value={category}
                >
                  <option value="">Todas</option>
                  {categories.map((item) => (
                    <option value={item.name} key={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className="relative w-full mt-0 md:w-[300px]">
              <label
                htmlFor="location"
                className="max-w-2xl mt-0 mb-8 text-sm font-semibold leading-6 text-neutral-800/90"
              >
                Buscar
              </label>
              <div className="relative">
                <input
                  type="text"
                  value={inputValue}
                  onChange={handleInputChange}
                  className="mt-1 block w-full !rounded-md border-0 py-3 md:py-3 pl-3 pr-10 text-gray-900 ring-1 ring-brand-main ring-inset mb-2 md:mb-8  text-base leading-6 text-neutral-800/90"
                />

                <svg
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 339.9 339.9"
                  xmlSpace="preserve"
                  fill="currentcolor"
                  onClick={() => {
                    if (inputValue !== '') {
                      setQuery(inputValue);
                      setPage('1');
                    }
                  }}
                  className={`absolute right-0 h-full text-white !rounded-r-md transition-all duration-150 ease-in-out bg-brand-main  p-3 -translate-y-1/2  w-12 top-1/2 ${
                    inputValue !== ''
                      ? 'cursor-pointer hover:bg-brand-dark shadow-2xl'
                      : 'cursor-default brightness-75'
                  }`}
                >
                  <g>
                    <path
                      className="st0"
                      d="M335.2,292.1L253.8,208c-5.8-6-13.1-8.4-16.3-5.4c-3.2,3.1-10.5,0.7-16.3-5.4L220,196
                        c36.4-47.9,32.9-116.5-10.9-160.2C161.4-11.9,84-11.9,36.3,35.8c-47.7,47.7-47.7,125.1,0,172.9c44.5,44.5,114.7,47.5,162.7,9
                        l0.5,0.5c5.8,6,8,13.4,4.8,16.5c-3.2,3.1-1,10.4,4.8,16.5l81.3,84.1c5.8,6,15.5,6.2,21.5,0.4l22.8-22.1
                        C340.8,307.7,341,298.1,335.2,292.1z M182.3,181.8c-32.9,32.9-86.3,32.9-119.2,0c-32.9-32.9-32.8-86.3,0-119.2
                        c32.8-32.9,86.3-32.8,119.1,0C215.2,95.5,215.2,149,182.3,181.8z"
                    />
                  </g>
                </svg>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-6 mx-auto mt-5 md:gap-8 auto-rows-fr lg:mx-0 lg:max-w-none sm:grid-cols-2 lg:grid-cols-3">
            {posts?.data ? (
              posts.data.map((item) => <BlogCard key={item.id} item={item} />)
            ) : loading && blogData.length !== 0 ? (
              <div className="flex justify-center w-full py-64 col-span-full">
                <PuffLoader color="#514b45" />
              </div>
            ) : null}
            {(posts?.data?.length === 0
              || blogData?.data?.length === 0
              || blogData.length === 0) && (
              <div className="flex flex-col items-center text-center col-span-full">
                <p className="text-xl md:text-3xl text-brand-dark payfair ">Sin resultados</p>
                <div className="relative my-5 rounded-full mx-autor bg-brand-main">
                  <Archive className="w-44 h-44 p-10 text-white " />
                </div>
              </div>
            )}
          </div>
          {posts && (
            <Pagination page={page} setPage={setPage} setPosts={setPosts} pages={posts.links} />
          )}
        </div>
      </section>
    </>
  );
}

Blog.propTypes = {
  blogData: PropTypes.object,
  categories: PropTypes.array,
};

export async function getServerSideProps() {
  const [blogData, categories] = await Promise.all([fetchAllPosts(), fetchCategories()]);

  return {
    props: {
      blogData,
      categories,
    },
  };
}
